module.exports = __webpack_public_path__ + "static/media/download iOS.0f3514a4.svg";